<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  height: 100%;
  width: 100%;
}
html,body{
  height: 100%;
  height: 100%;
  background-color: #f2f2f2;
  margin:0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue